import React from "react";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { FormField } from "../FormField/FormField";
import { LocationSelect } from "Components/Shared/LocationSelect/LocationSelect";
import { Option } from "Shared/types/Option";
import { useWatch } from "react-hook-form";
import { EmployerPermissions } from "generated/graphql";

export interface LocationsSelectFormFieldProps {
  defaultLocations?: Option[];
  disabled?: boolean;
  setLocationsFieldValue: (value: Option[]) => void;
  selectAllOption?: boolean;
}

export const LocationsSelectFormField = ({
  setLocationsFieldValue,
  defaultLocations,
  disabled,
  selectAllOption
}: LocationsSelectFormFieldProps) => {
  const { permissions } = useWatch({});
  const isFullPermissionSelected =
    permissions?.value === EmployerPermissions.FullPermissions;

  const { associatedLocationsCount } = usePartnerConfig();
  if (!associatedLocationsCount) {
    return null;
  }

  const filter = associatedLocationsCount === defaultLocations?.length
    ? [{ label: "All Locations selected", value: null }]
    : defaultLocations;

  return (
    <FormField fieldName="Location(s)">
      <LocationSelect
        filter={filter || []}
        onFilterChange={setLocationsFieldValue}
        maxMenuHeight={120}
        placeholder="Specify location access"
        disabled={disabled}
        selectAllOption={selectAllOption}
        isFullPermissionSelected={isFullPermissionSelected}
      />
    </FormField>
  );
};

